export interface DirectoryAddressModel {
  city: string;
  street: string;
  country: string;
}

export enum AddressType {
  CITY = 'city',
  STREET = 'street',
  COUNTRY = 'country',
}
